import { _ } from "js/vendor";

class Perf {
    constructor() {
        this.timers = {};
        this.logs = {};
    }

    init(type) {
        this.logs[type] = [];
    }

    start(type) {
        if (!this.logs[type]) this.init(type);

        this.timers[type] = performance.now();
    }

    stop(type) {
        this.logs[type] && this.logs[type].push(performance.now() - this.timers[type]);
    }

    reset() {
        this.logs = {};
        this.timers = {};
    }

    print() {
        for (let t of Object.keys(this.logs)) {
            let logs = this.logs[t];

            console.log("----------------------------------");
            console.log(t);
            console.log("count:", logs.length);
            console.log("avg:", _.sum(logs) / logs.length);

            logs.sort(function(a, b) {
                return a - b;
            });
            let mid = logs.length / 2;
            let median = mid % 1 ? logs[mid - 0.5] : (logs[mid - 1] + logs[mid]) / 2;

            console.log("med:", median);
            console.log("min:", _.min(logs));
            console.log("max:", _.max(logs));
            console.log("sum:", _.sum(logs));
        }
    }
}

export default new Perf();
